import { render, staticRenderFns } from "./CreditNoteMailPopup.vue?vue&type=template&id=00c0ebf7"
import script from "./CreditNoteMailPopup.vue?vue&type=script&lang=ts"
export * from "./CreditNoteMailPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports